declare global {
  interface Window {
    dataLayer?: any[]
    gtag?: (...args: any[]) => void
    __EP_GA_ID?: string
  }
}

/**
 * Подія «заявку відправлено».
 *
 * Пуш у dataLayer лишається для lp: його GTM-контейнер (GTM-M9XWWW7N) має власний тригер
 * на цю подію і сам відправляє її в GA4 та в Google Ads.
 *
 * Решта лендінгів (espanol, deutsch, online, kids) мають свої GTM-контейнери БЕЗ такого
 * тригера, і доступу до них у нас немає, тому там подія до GA4 не доходила взагалі.
 * Для них шлемо подію напряму через gtag на measurement id самої сторінки.
 *
 * Умова startsWith('G-') відсікає саме lp: у нього в конфізі замість measurement id лежить
 * GTM-id, і прямий виклик gtag там дав би другий, дубльований підрахунок тієї самої заявки.
 */
export const trackApplicationSend = () => {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'application_send' })

  const gaId = window.__EP_GA_ID

  if (gaId && gaId.startsWith('G-') && typeof window.gtag === 'function') {
    window.gtag('event', 'application_send', { send_to: gaId })
  }
}

export {}
